import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var Dashboard = function () {
    return (_jsx(_Fragment, {}));
};
export default Dashboard;
